import { render, staticRenderFns } from "./Component-RightPanel.vue?vue&type=template&id=af0c6ba8"
import script from "./Component-RightPanel.vue?vue&type=script&lang=js"
export * from "./Component-RightPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports